module.exports = __webpack_public_path__ + "img/Refer-272-512.2b6cea60.png";